import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, Input, Renderer2 } from '@angular/core';
import { map } from 'rxjs';
import { imageUploadConst, typeList } from 'src/assets/config/constants';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-image-upload',
    templateUrl: './image-upload.component.html',
    styleUrl: './image-upload.component.css',
    standalone: false
})
export class ImageUploadComponent {

  // @Input()
  loader: boolean = false;

  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  model: any = {

  };
  selectedType: any = {};
  barWidth: string = '0%';
  uploadImages: any = [];
  previewImages: any = {};
  uploadedFiles: Array<File>;
  invalidImg: boolean = false;
  private _renderer: Renderer2;
  typeList: any = typeList;
  copyClass: string | null = imageUploadConst.copyClass;
  copyLinkLabel: string | null = imageUploadConst.copyLinkLabel;

  constructor(private http: HttpClient) {


    this.breadcrumb = {
      'mainlabel': 'Offer Management',
    };
  }

  toggleCustomizer(event) {
    const element = document.getElementById('customizer');
    // console.log(element.classList);
    // element.classList.add('hll');
    // console.log(element.classList);
    if (element && element.classList.contains('open')) {
      element.classList.remove('open');
    } else {
      element.classList.add('open');
    }
  }

  changeType() {
    console.log(this.model.type);

    for (let i = 0; i < typeList.length; i++) {
      const element = typeList[i];
      if (element.name == this.model.type) {
        this.selectedType = element;
      } else if (this.model.type == 'select') {
        this.selectedType = {};
      }
    }
    console.log(this.uploadedFiles);
  }

  fileChange(ev) {
    this.previewImages = [];
    this.barWidth = '0%';
    this.model.imageUrl = '';

    this.uploadedFiles = ev.target.files;
    console.log(ev.target.files);


    const element = ev.target.files[0];
    let reader = new FileReader();

    reader.readAsDataURL(element);
    reader.onload = (evn: any) => {
      // To get image dimensions
      const img = new Image();
      img.src = window.URL.createObjectURL(element);
      let interval = setInterval(() => {
        if (img.height != 0 && img.width != 0) {
          this.previewImages = {
            height: img.height,
            width: img.width,
            url: evn.target.result
          };
          clearInterval(interval);
        }
      }, 1000);
    }
    // for (let i = 0; i < ev.target.files.length; i++) {

    // }

  }


  // fileChange(ev) {

  //   if ((ev.target.files.length + this.previewImages.length) > 4) {
  //     alert("Please select max 4 files.");
  //     // e.preventDefault();
  //   } else {
  //     // console.log(this.uploadedFiles);
  //     if (this.uploadedFiles != undefined) {

  //       this.uploadedFiles = [...this.uploadedFiles, ...ev.target.files];
  //     } else {
  //       this.uploadedFiles = ev.target.files;
  //     }

  //     for (let i = 0; i < ev.target.files.length; i++) {
  //       const element = ev.target.files[i];
  //       let reader = new FileReader();

  //       reader.readAsDataURL(element);
  //       reader.onload = (evn: any) => {
  //         // To get image dimensions
  //         const img = new Image();
  //         img.src = window.URL.createObjectURL(element);
  //         let interval = setInterval(() => {
  //           if (img.height != 0 && img.width != 0) {
  //             this.previewImages.push({
  //               height: img.height,
  //               width: img.width,
  //               url: evn.target.result
  //             });
  //             clearInterval(interval);
  //           }
  //         }, 1000);
  //       }
  //     }
  //   }
  // }
  checkDimensions() {
    console.log(this.previewImages);

    // for (let i = 0; i < this.previewImages.length; i++) {
    //   const element = this.previewImages[i];
    //   if (element.height > 600 || element.width > 600) {
    //     element.isvalid = false;
    //     this.invalidImg = true;
    //   } else {
    //     element.isvalid = true;

    //     this.invalidImg = false;
    //   }
    // }
    if (this.previewImages.height > this.selectedType.height || this.previewImages.width > this.selectedType.width) {
      this.previewImages.isvalid = false;
      this.invalidImg = true;
    } else {
      this.previewImages.isvalid = true;
      this.invalidImg = false;
    }
    console.log(this.previewImages);

  }
  upload() {
    this.checkDimensions();
    if (this.invalidImg)
      return;

    if (this.uploadedFiles != undefined && this.uploadedFiles.length != 0) {
      let formData = new FormData();
      formData.append("name", "product");
      formData.append("type", "image");
      // formData.append("name", "category");
      console.log(this.uploadedFiles);

      for (var i = 0; i < this.uploadedFiles.length; i++) {
        // formData.append("banner", this.uploadedFiles[i], this.uploadedFiles[i].name);
        formData.append("image", this.uploadedFiles[i], this.uploadedFiles[i].name);
      }
      console.log(formData);

      this.http.post(environment.baseAPIHost + '/admin/upload', formData, {
        reportProgress: true,
        observe: "events"
      })
        .pipe(map(
          event => {
            if (event.type == HttpEventType.UploadProgress) {
              console.log(HttpEventType.UploadProgress);
              this.barWidth = Math.round((100 / (event.total || 0) * event.loaded)) + '%';
              if (event.total == event.loaded) {

              }
            } else if (event.type == HttpEventType.Response) {

              // this.isImageSelected = true;
              console.log(event.body['data'].imageUrl);

              for (let i = 0; i < event.body['data'].imageUrl.length; i++) {
                const element = event.body['data'].imageUrl[i];
                this.model.imageUrl = element;
                // this.uploadImages.push(element);
              }
              // this.model.imageUrl = this.uploadImages[0];

              // this.barWidth = '0%';
            }
          }
        ))

        .subscribe((response: any) => {
          // // console.log('response received is ', response);
          // this.isImageSelected = true;
          // for (let i = 0; i < response.data.imageUrl.length; i++) {
          //   const element = response.data.imageUrl[i];
          //   // this.model.imageUrl.push(element);
          //   this
          //   this.uploadImages.push(element);
          // }

          // this.model.imageUrl = this.uploadImages;

        })
    } else {
      console.log('ESSSSS');

    }

  }
  deleteImage(i: any, item: any) {
    this.previewImages.splice(i, 1);
    this.uploadedFiles.splice(i, 1);
  }
  saveImages(valid) {
    if (valid) {
      let parameter: any = {
        methodType: "POST",
      }
    }
  }

  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
  
    this.copyClass = imageUploadConst.copyClassAfterCopy;
    this.copyLinkLabel = imageUploadConst.copyLinkAfterCopy;
    setTimeout(() => {
      this.copyClass = imageUploadConst.copyClass;
      this.copyLinkLabel = imageUploadConst.copyLinkLabel;
      document.body.removeChild(selBox);
    }, 3000);
    
  }
}
